import { t } from 'i18next';
import Heading from '~/components/Shared/Heading/Heading';
import Page from '~/components/Shared/Layout/Page/Page';
import { Link } from 'react-router-dom';
import styles from './Leisures.module.scss';
import { useQuery } from '@tanstack/react-query';
import { instance } from '~/utils/api/api';
import { useToastError } from '~/utils/useToastError';
import { Pagination, Spinner } from '~/ui';
import { useState } from 'react';

interface IGame {
  current_page: number;
  data: {
    id: number;
    name: string;
    description: string;
    asset_id: number;
    full_logo_path: string;
    asset: {
      id: number;
      name: string;
    };
    accommodations: {
      id: number;
      game_information_id: number;
      accommodation_id: number;
    }[];
    organizations: { id: number }[];
  }[];
  total_pages: number;
  last_page: number;
}

const Leisures = () => {
  const [page, setPage] = useState(1);
  const toastError = useToastError();

  const { data: games, isLoading } = useQuery<IGame>({
    queryFn: async () => {
      const { data } = await instance.get('admin/game-info', {
        params: {
          page: page,
          perPage: 5,
        },
      });
      return data;
    },
    queryKey: ['leisures', page],
    onError: error => {
      toastError(error);
    },
  });

  return (
    <Page heading={<Heading text={t('entertainment')} />}>
      {games && !isLoading ? (
        <ul className={styles.gameList}>
          {games.data.map(item => (
            <li
              className={styles.gameItem}
              key={item.id}
              style={{
                background: `url(${item.full_logo_path})`,
                backgroundPosition: 'center',
                backgroundSize: 'cover',
              }}
            >
              <Link to={`${item.id}`} className={styles.gameLink}>
                <div className={styles.gameTitleWrapper}>
                  <p className={styles.gameTitle}>{item.name}</p>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      ) : (
        <Spinner />
      )}
      {games && !isLoading && games.data.length > 5 && (
        <Pagination
          pageCount={games?.last_page}
          onPageChange={(selectedPage: { selected: number }) => {
            setPage(selectedPage.selected + 1);
          }}
        />
      )}
    </Page>
  );
};
export default Leisures;
